"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Bin;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Bin(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "bin"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M75.05,31.076a2.5,2.5,0,0,0-2.5,2.5V87.5H27.45V33.576a2.5,2.5,0,0,0-5,0V88.735A3.769,3.769,0,0,0,26.214,92.5H73.786a3.769,3.769,0,0,0,3.764-3.765V33.576A2.5,2.5,0,0,0,75.05,31.076Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M43.44,79.4V33.763a2.5,2.5,0,0,0-5,0V79.4a2.5,2.5,0,0,0,5,0Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M61.56,79.4V33.763a2.5,2.5,0,0,0-5,0V79.4a2.5,2.5,0,0,0,5,0Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M79.074,18.711H63.035v-3.59A7.63,7.63,0,0,0,55.414,7.5H44.586a7.63,7.63,0,0,0-7.621,7.621v3.59H20.926a2.5,2.5,0,0,0,0,5H79.074a2.5,2.5,0,0,0,0-5Zm-37.109-3.59A2.624,2.624,0,0,1,44.586,12.5H55.414a2.624,2.624,0,0,1,2.621,2.621v3.59H41.965Z"
  })))));
}